import React, { useEffect, useState } from 'react'
import { useGlobalContext } from '../context'

import ReactWhatsapp from 'react-whatsapp';

function Buying() {
    const { bag, buying, setBuying, total, totalItems, seondBag } = useGlobalContext()
    const [itemObj, setItemObj] = useState({});
    const [itemsArray, setItemsArray] = useState([])

    useEffect(() => {
        bag.map((item) => {
            const { name, price, amount, chossenSize } = item
            setItemObj(name, price, amount, chossenSize)
            setItemsArray((oldItems) => {
                return [...oldItems, itemObj]
            })
        })
    }, [])
    console.log(itemsArray);

    if (bag.length > 0) {

        return (
            <div className='buying'>
                <div className="container">
                    <div className="items">
                        {
                            bag.map((item) => {
                                const { id, name, price, image, chossenSize, amount } = item



                                return (
                                    <div className="item" key={id}>
                                        <h3 className='item-name'>{amount} | {name}</h3>
                                        <h4 className='item-price'>{amount * price} <span>LE</span> </h4>
                                        <h4 className='item-size'>size: {chossenSize}</h4>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="total">
                        <h2>total items: {totalItems}</h2>
                        <h2>total price: {total} LE</h2>
                    </div>

                    <ReactWhatsapp number="+20 106 529 6468" message={JSON.stringify(...bag)} className='buy-now'>
                        Send Your Order To What'sApp
                    </ReactWhatsapp>
                </div>
            </div>
        )
    } else {
        return <h1>You don't have order yet</h1>
    }

}

export default Buying